import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import {
  InsuranceClaimFormModel,
  InsuranceClaimModel,
  InsuranceClaimStatusFlow,
  InsuranceClaimStatusHistoryModel,
  insuranceClaimFeatureKey,
} from './types';
import { Action } from '../view/types';
import { IInsuranceClaimState } from './insurance-claim.reducer';

const insuranceClaimFeatureState = createFeatureSelector<IInsuranceClaimState>(
  insuranceClaimFeatureKey,
);

export const insuranceClaimSelectors = {
  getById: createApiCallSelectors<InsuranceClaimModel, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'getById',
  ),
  getByUniqueId: createApiCallSelectors<
    InsuranceClaimModel,
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'getByUniqueId'),
  createInstance: createApiCallSelectors<
    InsuranceClaimFormModel,
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'createInstance'),
  add: createApiCallSelectors<InsuranceClaimModel, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'add',
  ),
  update: createApiCallSelectors<InsuranceClaimModel, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'update',
  ),
  generateDocuments: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'generateDocuments',
  ),
  requestValidation: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'requestValidation',
  ),
  validate: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'validate',
  ),
  openDossierToTransmitter: createApiCallSelectors<
    boolean,
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'openDossierToTransmitter'),
  openClaim: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'openClaim',
  ),
  close: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'close',
  ),
  reopen: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'reopen',
  ),
  reject: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'reject',
  ),
  getStatusHistory: createApiCallSelectors<
    InsuranceClaimStatusHistoryModel,
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'getStatusHistory'),
  updateStatusHistory: createApiCallSelectors<
    InsuranceClaimStatusHistoryModel,
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'updateStatusHistory'),
  deleteStatusHistory: createApiCallSelectors<boolean, IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'deleteStatusHistory',
  ),
  getStatusFlow: createApiCallSelectors<
    InsuranceClaimStatusFlow[],
    IInsuranceClaimState
  >(insuranceClaimFeatureState, 'getStatusFlow'),
  getStatusActions: createApiCallSelectors<Action[], IInsuranceClaimState>(
    insuranceClaimFeatureState,
    'getStatusActions',
  ),
};
